import(/* webpackMode: "eager", webpackExports: ["CustomerAccount"] */ "/app/src/components/cart/CustomerAccount.tsx");
